import styled from "styled-components";
import { Row, Col, Divider } from "antd";
import StyledInput from "@/components/ui/Input";
import { FieldWrap } from "@/components/styled/Forms";
import { Field } from "@/modules/forms/Blocks";
import SectionHeader from "../common/SectionHeader";

const StyledContainer = styled.div`
  .message-textarea {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    margin-top: 20px;
    padding: 0;
    color: #909090;
  }

  .textarea-box {
    // min-height: 224px;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    border-radius: 4px;
    padding: 17px 16px 17px 16px;
    margin-top: 16px;
  }
  .textarea-box .ant-input {
    height: 142px;
    background: #FAFAFA !important;
    border-radius: 0 !important; 
    margin:0 !important;
    padding: 7px 14px 14px;
    font-style: italic;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #707070;
   }
    .inner-input {
        margin-top: 16px !important;
    }
    @media (max-width: 420px) {
        .first-row {
            margin-top: 28px;
        }
        .panel-header {
            display: none;
        }
      .message-textarea {
        margin-top: 0;
      }

        .inner-input {
            margin-top: 0px !important;
        }
        .ant-input {
            min-height: 37px;
            max-height: 37px;
        }
        .textarea-box {
            border: none;
            background: #FFFFFF;
            padding: 0;
            margin-top: 16px;
        }

        .textarea-box .ant-input {
            min-height: 142px !important;
            background: #FFF !important;
            border-radius: 10px !important; 
            margin:0 !important;
            padding: 7px 14px 14px;
            font-style: italic;
            font-weight: 300;
            font-size: 14px;
            line-height: 16px;
            color: #707070;
        }
    }
`
const ContactInfo = ({ appointmentForm }) => {
    function renderAddressFields() {
        if (appointmentForm.state?.values?.location === "in-store") {
            return null;
        }
        return (
            <>
                <Field
                    name="address"
                    placeholder="Straat & huisnummer"
                    // label="Straat & huisnummer"
                    autoComplete="street-address"
                    as={StyledInput}
                />
                <Col span={12} style={{ paddingRight: "10px", marginTop: "20px" }} className="inner-input">
                    <Field name="city"
                        // label="Stad"
                        as={StyledInput}
                        placeholder="Stad" />
                </Col>
                <Col span={12} style={{ paddingLeft: "10px", marginTop: "20px" }} className="inner-input">
                    <Field
                        name="zip"
                        // label="Postcode"
                        placeholder="Postcode"
                        as={StyledInput}
                        autoComplete="postal-code"
                    />
                </Col>
            </>
        );
    }
    return (
        <StyledContainer>
            <Row type="flex" gutter={0}>
                <Col span={24}>
                    <SectionHeader title="Contact gegevens" classes="panel-header" />
                </Col>
                <Row type="flex" style={{ minWidth: "100%" }} className="first-row">
                    <Col span={12} style={{ paddingRight: "10px" }}>
                        <Field
                            name="name"
                            placeholder="Naam"
                            as={StyledInput}
                            className="field-input"
                        />
                    </Col>
                    <Col span={12} style={{ paddingLeft: "10px" }}>
                        <Field
                            name="tel"
                            placeholder="Telefoon nummer"
                            autoComplete="tel"
                            as={StyledInput}
                        />

                    </Col>
                </Row>

                <Col span={24} style={{ marginTop: "20px" }} className="inner-input">
                    <Field
                        name="email"
                        placeholder="E-mail adres"
                        autoComplete="email"
                        as={StyledInput}
                    />
                </Col>
                <Col span={24}>
                    <Row type="flex" style={{ minWidth: "100%", marginTop: "20px" }}>

                        {renderAddressFields()}
                    </Row>
                </Col>
                <Col span={24} className="message-textarea">
                    Heb je een aanvullende opmerking of vraag? Laat het
                    ons weten.
                </Col>
                <Col span={24}>
                    <div className="textarea-box">
                        <Field
                            as={StyledInput}
                            textarea={true}
                            rows={6}
                            name="enquiry"
                        />
                    </div>
                </Col>
            </Row>
        </StyledContainer>
    )
}

export default ContactInfo
